function updateAbsoluteElementPosition() {
  const elA = document.querySelector(
    "variant-picker .variant-picker__option:last-of-type"
  );
  const elB = document.querySelector(
    "[data-block-type='permanent-liquid']:has(.best-fit-size-chart)"
  );

  if (elA && elB) {
    const elAHeight = elA.offsetHeight;
    const offset = `-${elAHeight + 24}px`;
    document.body.style.setProperty("--elB-position", "relative");
    document.body.style.setProperty("--elB-top", offset);
    document.body.style.setProperty("--elB-text-align", "right");
  } else {
  }
}

document.addEventListener("DOMContentLoaded", function () {
  updateAbsoluteElementPosition();
  window.addEventListener("resize", updateAbsoluteElementPosition);
});
